module.exports = __webpack_public_path__ + "img/尴尬.d380c56d.gif";